<template>
    <div class="designerpage">

        <div class="alert-bright align-center mt-2" v-show="!mdd">
          Need more than 1? You can now select a quantity in the basket
        </div>

        <hallmark-designer-question-door-range
          v-if="range_panel_required"
          :fabricator="fabricator"
          v-model:target="door.attr.door_range"
          :ranges="ranges"
          :defaults="defaults()"
          :title="panel_designer ? 'Please select a Panel Collection' : 'Please select a Door Collection'"
          :reference_on="reference_on"
          :designer_range_section_banners="designer_range_section_banners"
        ></hallmark-designer-question-door-range>

        <div class="designeroption hallmark-designer-standard-features-box" v-show="!mdd">
            <h3 class="align-center">
                30 Years of British Manufacturing History
            </h3>

            <div class="hallmark-designer-standard-features-box-top-image">
                <img :src="'/images/hallmark/hallmark-no1-manufacturer-banner.png'" alt="banner">
                <div class="pl-10 pr-10">
                    <img :src="'/images/hallmark/hallmark-no1-manufacturer-banner-trustpilot-quotes.png'" alt="trustpilot">
                </div>
            </div>

            <div class="stylesoption designer-question-tiled-layout _2-col">
                <div class="tile _left">
                    <div class="pb-1">
                        <i class="fa fa-check pr-1"></i>
                        Steel Reinforced Outerframe As Standard
                    </div>
                    <div class="pb-1">
                        <i class="fa fa-check pr-1"></i>
                        Aluminium Edge Banding As Standard
                    </div>
                    <div class="pb-1">
                        <i class="fa fa-check pr-1"></i>
                        Multipoint Locking System As Standard
                    </div>
                    <div class="pb-1">
                        <i class="fa fa-check pr-1"></i>
                        Security Accreditations Available
                    </div>
                    <div class="pb-1">
                        <i class="fa fa-check pr-1"></i>
                        150+ Door Designs
                    </div>
                    <div class="pb-1">
                        <i class="fa fa-check pr-1"></i>
                        2000+ Colours
                    </div>
                </div>
                <div class="tile _right">
                    <div class="pb-1">
                        <i class="fa fa-check pr-1"></i>
                        12 Hardware Finishes
                    </div>
                    <div class="pb-1">
                        <i class="fa fa-check pr-1"></i>
                        In-House Colour Bonding
                    </div>
                    <div class="pb-1">
                        <i class="fa fa-check pr-1"></i>
                        In-House Glass Shop
                    </div>
                    <div class="pb-1">
                        <i class="fa fa-check pr-1"></i>
                        Paint made in house
                    </div>
                    <div class="pb-1">
                        <i class="fa fa-check pr-1"></i>
                        Free UK Delivery
                    </div>
                </div>
            </div>

        </div>

        <div class="designeroption" v-if="is_expressrange">
            <h3>What is express delivery?</h3>
            <div class="stylesoption">
                <p>
                    Hallmark composite doors are made to order and whilst we have some of the fastest lead times in the
                    UK we want to offer you doors even quicker.
                </p>
                <p>
                    Express delivery doors are off the shelf and ready to dispatch instantly for when you need an urgent
                    door.
                </p>
                <p>
                    These doors are not customisable and come in a set size, colour, glass etc. We have chosen the most
                    popular configurations suitable for a front door, back door and utility door.
                </p>
                <p>
                    These are the same quality doors from the main range with the same 10 year warranty.
                </p>
                <p>
                    These doors cannot be modified or ordered with extras. These must be ordered from the main range.
                </p>
            </div>
        </div>

        <designer-question-select-door
            v-if="!panel_designer"
            :fabricator="fabricator"
            :secured-by-design="door.attr.secured_by_design"
            :door-range="door.attr.door_range"
            v-model:target="door.attr.slab"
            title="Choose Your Door Design"
        ></designer-question-select-door>

        <designer-question-steel-inserts
            :fabricator="fabricator"
            :slab="door.attr.slab"
            v-model:target="door.attr.steel_inserts"
        ></designer-question-steel-inserts>

        <designer-question-panel-category-with-thumbnails
            v-if="panel_designer"
            :fabricator="fabricator"
            :secured-by-design="door.attr.secured_by_design"
            :door-range="door.attr.door_range"
            v-model:target="door.attr.panel_category"
            :modifier_class="'_wide'"
        ></designer-question-panel-category-with-thumbnails>

          <div class="designeroption" v-if="panel_designer">
              <h3>
                Panel Options
              </h3>
              <div class="stylesoption">
                  <strong class="txt-positive" style="font-weight: 900;">
                      ☝️Can't find the panel design you are looking for? Choose one of the other categories for more designs. ☝️
                  </strong>
              </div>
              <designer-question-panel-core
                :fabricator="fabricator"
                :panel-category="door.attr.panel_category"
                v-model:target="door.attr.panel_core"
              ></designer-question-panel-core>
              <designer-question-panel-depth
                :fabricator="fabricator"
                :panel-category="door.attr.panel_category"
                v-model:target="door.attr.panel_depth"
              ></designer-question-panel-depth>
              <designer-question-panel-depth-bespoke
                :fabricator="fabricator"
                :panel-depth="door.attr.panel_depth"
                v-model:target="door.attr.panel_depth_bespoke"
              ></designer-question-panel-depth-bespoke>
          </div>

            <designer-question-select-panel
                v-if="panel_designer"
                :fabricator="fabricator"
                :secured-by-design="door.attr.secured_by_design"
                :door-range="door.attr.door_range"
                :panel-category="door.attr.panel_category"
                v-model:target="door.attr.slab"
            ></designer-question-select-panel>

            <div class="alert-bright align-center mt-2" v-show="panel_designer && !mdd">
                Multiple quantities can be added in basket
            </div>

        <div class="designeroption" v-if="is_firedoorrange">
            <div class="stylesoption">
                Need to order more than 10 composite fire doors? Then please make enquiry for commercial price list.
                <strong><a href="mailto:information@hallmarkpanels.com">information@hallmarkpanels.com</a> </strong>
            </div>
        </div>

        <designer-question-slab-cassettes
            v-model:target="door.attr.slab_cassette"
            :slab="door.attr.slab"
            :type-range="door.attr.door_range"
            :fabricator="fabricator"
        ></designer-question-slab-cassettes>

        <designer-question-panel-trim
            :fabricator="fabricator"
            :slab="door.attr.slab"
            v-model:target="door.attr.panel_trim"
        ></designer-question-panel-trim>

        <div class="designeroption">
            <designer-question-frame-material
                :slab="door.attr.slab"
                :fabricator="fabricator"
                v-model:target="door.attr.frame_material"
            ></designer-question-frame-material>
        </div>

        <hallmark-designer-question-select-frame-style
            v-show="!is_inspirationsrange && !panel_designer && !is_expressrange && !slab_only"
            :fabricator="fabricator"
            :is-firedoor="is_firedoorrange"
            :frame-material="door.attr.frame_material"
            v-model:target="door.attr.frame_style"
            :type-range="door.attr.door_range"
            :floating_sidebar_message="(!is_firedoorrange && !is_stable && !panel_designer && !mdd) ? 'Side lights come with either a 6mm or 20mm coupler' : ''"
        ></hallmark-designer-question-select-frame-style>

        <designer-question-trickle-vents
            v-if="!panel_designer && !is_expressrange && !is_firedoorrange && !slab_only"
            :fabricator="fabricator"
            v-model:target="door.attr.trickle_vents"
            :frame="door.attr.frame_style.frame_id"
            :floating_sidebar_message="(!mdd) ? 'Trickle Vents may incur a installation surcharge' : 'Trickle Vents may incur a installation surcharge <div class=\'txt-sm\'>Installers may need to present this note to their customers</div>'"
            :extra_html="(!mdd) ? '<div class=\'mt-3\'>Trickle Vents may incur a installation surcharge</div>' : '<div class=\'mt-3\'>Trickle Vents may incur a installation surcharge <div class=\'txt-sm\'>Installers may need to present this note to their customers</div></div>'"
        ></designer-question-trickle-vents>

        <div class="designeroption" v-if="!panel_designer">
            <designer-question-hinge-side :fabricator="fabricator"
                                          v-model:target="door.attr.hinge_side"></designer-question-hinge-side>
        </div>

        <div class="designeroption" v-show="!is_inspirationsrange && !panel_designer && !is_expressrange">
            <designer-question-opening-direction v-show="technical_should_show" :fabricator="fabricator"
                                                 v-model:target="door.attr.opening_direction"
                                                 :frame-combination="door.attr.frame_style.frame_id"
                                                 :type-range="door.attr.door_range"
            ></designer-question-opening-direction>
        </div>

        <div class="designeroption" v-show="!panel_designer && !is_firedoorrange && !is_inspirationsrange && !is_expressrange && !is_stable">
            <div class="designer-floating-sidebar-message">
                <i class="fa fa-circle-question"></i>
                Choosing this option may remove some design options
            </div>
            <h3>Signature Deluxe</h3>
            <hallmark-designer-question-collection-signature-deluxe
                :fabricator="fabricator"
                v-model:target="door.attr.collection"
                :question="'signature_deluxe'"
                :mdd="mdd"
                :slab="door.attr.slab"
            ></hallmark-designer-question-collection-signature-deluxe>
        </div>

        <template v-if="!is_expressrange">
          <hallmark-designer-question-colour-range
            title="Colour Ranges"
            :fabricator="fabricator"
            :collection="door.attr.collection"
            :type-range="door.attr.door_range"
            :panel-category="door.attr.panel_category"
            v-model:target="door.attr.colour_range"
          ></hallmark-designer-question-colour-range>
        </template>

        <div class="designeroption" data-designer-component-id="door_colour" v-show="!is_expressrange">
          <h3 v-if="panel_designer">Choose Your Panel Colour
            <a href="https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/8/HallmarkPanelConversion.pdf" class="designer-question-popup-info-link hallmark-choose-panel-colour-info" target="_blank">
              Not sure what white profile you need? <br>
              <span class="txt-danger">Click here</span> - panel conversion chart
            </a>
          </h3>
          <h3 v-else>Choose Your Door Colour</h3>
            <div class="designer-floating-sidebar-message" v-if="!is_firedoorrange && !is_stable && !panel_designer && !mdd">
                <i class="fa fa-circle-question"></i>
                Standard Colour Closest RAL<br>
                (Not exact match, use sample first)<br>
                White RAL9016  Blue RAL5004<br>
                Black RAL9005  Green RAL6009<br>
                Red NCS S3560-Y90R<br>
                Anthracite Grey - RAL7016<br>
                Chartwell Green, Rosewood & Golden Oak - Do not have a RAL colour
            </div>
            <div class="colourtabs">
                <ul>
                    <li><a href="#dc-tabs-1">External Colour</a></li>
                    <li><a href="#dc-tabs-2">Internal Colour</a></li>
                </ul>
                <div id="dc-tabs-1">
                    <wb-designer-question-door-colour-external :fabricator="fabricator" :slab="door.attr.slab"
                                                               :door-range="door.attr.door_range"
                                                               :colour-range="door.attr.colour_range"
                                                               :slab-cassette="door.attr.slab_cassette"
                                                               v-model:target="door.attr.external_colour"></wb-designer-question-door-colour-external>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.external_colour"
                                                  title="External Door Colour"
                                                  :label="panel_designer ? 'Enter your system supplier here' : ''"
                                                  v-model:target="door.attr.external_colour_ral"></designer-question-ral-colour>
                </div>
                <div id="dc-tabs-2">
                    <hallmark-designer-question-door-colour-internal :fabricator="fabricator" :slab="door.attr.slab"
                                                               :external-colour="door.attr.external_colour"
                                                               :door-range="door.attr.door_range"
                                                               :colour-range="door.attr.colour_range"
                                                               :slab-cassette="door.attr.slab_cassette"
                                                               v-model:target="door.attr.door_colour_internal"></hallmark-designer-question-door-colour-internal>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.door_colour_internal"
                                                  title="Internal Door Colour"
                                                  :label="panel_designer ? 'Enter your system supplier here' : ''"
                                                  v-model:target="door.attr.door_colour_internal_ral"></designer-question-ral-colour>
                </div>
            </div>
            <div class="stylesoption" v-if="is_firedoorrange">
                PLEASE NOTE - Due to the limited availability of stock in specific colours, a RAL upgrade maybe required to fulfil your order.
            </div>
        </div>

        <div class="designeroption" data-designer-component-id="frame_colour" v-show="!panel_designer && !is_expressrange && !slab_only">
            <h3>Pick Your Frame Colour</h3>

            <div class="designer-floating-sidebar-message">
                <i class="fa fa-circle-question"></i>
                Coloured frame may require matching trims
            </div>

            <div class="colourtabs">
                <ul>
                    <li><a href="#tabs-1">External Colour</a></li>
                    <li><a href="#tabs-2">Internal Colour</a></li>
                </ul>
                <div id="tabs-1">
                    <wb-designer-question-frame-colour-external :fabricator="fabricator"
                                                                :frame-material="door.attr.frame_material"
                                                                :slab="door.attr.slab"
                                                                :door-range="door.attr.door_range"
                                                                :slab-cassette="door.attr.slab_cassette"
                                                                :colour-range="door.attr.colour_range"
                                                                v-model:target="door.attr.frame_colour_external"></wb-designer-question-frame-colour-external>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.frame_colour_external"
                                                  title="External Frame Colour"
                                                  :label="panel_designer ? 'Enter your system supplier here' : ''"
                                                  v-model:target="door.attr.frame_colour_external_ral"></designer-question-ral-colour>
                </div>
                <div id="tabs-2">
                    <wb-designer-question-frame-colour-internal :fabricator="fabricator"
                                                                :frame-material="door.attr.frame_material"
                                                                :frame-colour-external="door.attr.frame_colour_external"
                                                                :slab="door.attr.slab"
                                                                :door-range="door.attr.door_range"
                                                                :slab-cassette="door.attr.slab_cassette"
                                                                :colour-range="door.attr.colour_range"
                                                                v-model:target="door.attr.frame_colour_internal"></wb-designer-question-frame-colour-internal>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.frame_colour_internal"
                                                  title="Internal Frame Colour"
                                                  :label="panel_designer ? 'Enter your system supplier here' : ''"
                                                  v-model:target="door.attr.frame_colour_internal_ral"></designer-question-ral-colour>
                </div>
            </div>
            <div class="stylesoption" v-if="mdd">
                <p>
                    Coloured frame may require matching trims
                </p>
                <p>
                    Installers may need to present this note to their customers
                </p>
            </div>
        </div>

        <div>
            <hallmark-designer-question-secured-by-design
                    v-show="!is_firedoorrange && !is_inspirationsrange && !panel_designer && !is_expressrange && !is_double_rebate_range && !is_stable && !slab_only"
                    :fabricator="fabricator"
                    v-model:target="door.attr.secured_by_design"
                    :collection="door.attr.collection"
                    :title="'Do you require enhanced security?'"
                    :floating_sidebar_message="(!is_firedoorrange && !is_stable && !panel_designer) ? 'Choosing this option may remove some design options. This option increases the price.' : ''"
                    :extra_html="(!is_firedoorrange && !is_stable && !panel_designer) ? '<div class=\'align-center pb-3\'> Choosing this option may remove some design options. This option increases the price.</div>' : ''"
            ></hallmark-designer-question-secured-by-design>

            <designer-question-door-glass-laminated v-show="!is_inspirationsrange && !is_expressrange" :fabricator="fabricator"
                                                    title="Laminated Glass:"
                                                    :slab="door.attr.slab"
                                                    :frame-style="door.attr.frame_style"
                                                    :side-panels="door.attr.side_panels"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :is-firedoor="is_firedoorrange"
                                                    :collection="door.attr.collection"
                                                    :door_range="door.attr.door_range"
                                                    v-model:target="door.attr.laminated_glass"
                                                    floating_sidebar_message="Choosing this option may remove some design options. This option increases the price."
                                                    :extra_html="'<div class=\'align-center pb-3\'> Choosing this option may remove some design options. This option increases the price.</div>'"
            ></designer-question-door-glass-laminated>

            <designer-question-door-glass-argon
                v-show="!is_inspirationsrange && !is_firedoorrange && !panel_designer && !is_expressrange && !is_stable && !mdd"
                :fabricator="fabricator"
                title="ThermalPro:"
                :slab="door.attr.slab"
                v-model:target="door.attr.argon_glass"
            ></designer-question-door-glass-argon>
        </div>

        <div>
            <wb-designer-question-glass-design :fabricator="fabricator"
                                               v-model:target="door.attr.glass_design"
                                               :laminated-glass="door.attr.laminated_glass"
                                               :argon-glass="door.attr.argon_glass"
                                               :door-range="door.attr.door_range"
                                               :slab="door.attr.slab"
                                               :title="'Select A Glass Design For Your Door - (D) = Double Glazed (T) = Triple Glazed'"
            ></wb-designer-question-glass-design>

            <designer-question-glass-text v-model:target="door.attr.glass_text"
                                          :glass-design="door.attr.glass_design"
            ></designer-question-glass-text>

            <designer-question-glass-font
                :fabricator="fabricator"
                :glass-design="door.attr.glass_design"
                :glass-text="door.attr.glass_text"
                v-model:target="door.attr.glass_font"
            ></designer-question-glass-font>

        </div>

        <wb-designer-question-glass-backing-design :fabricator="fabricator"
                                                   v-model:target="door.attr.glass_backing_design"
                                                   :slab="door.attr.slab"
                                                   :door-range="door.attr.door_range"
                                                   :glass-design="door.attr.glass_design"></wb-designer-question-glass-backing-design>

        <hallmark-designer-question-select-frame-sidepanels :fabricator="fabricator"
                                                            v-model:target="door.attr.side_panels"
                                                            :door-range="door.attr.door_range"
                                                            :frame-style="door.attr.frame_style"
                                                            :frame-profile="door.attr.profile"
                                                            :frame-material="door.attr.frame_material"
                                                            :laminated-glass="door.attr.laminated_glass"
                                                            :frame-colour-internal="door.attr.frame_colour_internal"
                                                            :frame-colour-external="door.attr.frame_colour_external"
                                                            :secured-by-design="door.attr.secured_by_design"
                                                            :slab="door.attr.slab"
                                                            :measurements.sync="door.attr.measurements"
                                                            :limits="limits"
        ></hallmark-designer-question-select-frame-sidepanels>



        <div v-show="!is_expressrange">
            <hallmark-designer-question-hardware-suite-selector v-if="!is_firedoorrange && door.attr.door_range !== 132"
                                                                :fabricator="fabricator"
                                                                v-model:target="door.attr.hardware_suite"
                                                                :door-range="door.attr.door_range"
                                                                :slab="door.attr.slab"
                                                                :secured-by-design="door.attr.secured_by_design"
                                                                :opening-direction="door.attr.opening_direction"
                                                                :profile="door.attr.profile"
                                                                :collection="door.attr.collection"
                                                                :suites="suites"></hallmark-designer-question-hardware-suite-selector>
        </div>
        <div v-show="!is_expressrange && door.attr.door_range !== 132">

            <wb-designer-question-hardware-colour-with-suite :fabricator="fabricator"
                                                             v-model:target="door.attr.hardware_colour"
                                                             :sbd="door.attr.secured_by_design"
                                                             :slab="door.attr.slab"
                                                             :hardware-suite="door.attr.hardware_suite"
                                                             :door-range="door.attr.door_range"
                                                             :profile="door.attr.profile"
                                                             :opening-direction="door.attr.opening_direction">
            </wb-designer-question-hardware-colour-with-suite>
        </div>
        <div v-show="!is_expressrange && door.attr.door_range !== 132">
            <wb-designer-question-hardware-handle-with-suite :fabricator="fabricator"
                                                             v-model:target="door.attr.hardware_handle"
                                                             :slab="door.attr.slab"
                                                             :secured-by-design="door.attr.secured_by_design"
                                                             :opening-direction="door.attr.opening_direction"
                                                             :hardware-colour="door.attr.hardware_colour"
                                                             :hardware-suite="door.attr.hardware_suite"
                                                             :door-range="door.attr.door_range"
                                                             :profile="door.attr.profile"
                                                             :extra_text="door.attr.hardware_handle === 361 || door.attr.hardware_handle === 1391 ? 'Please note this handle is NOT powder coated' : 'Sweet offer 20-year anti corrosion guarantee, Nuki may incur an installation surcharge from the installer'"
                                                             :floating_sidebar_message="(!is_firedoorrange && !is_stable && !panel_designer) ? 'Sweet offer 20-year anti corrosion guarantee, Nuki may incur an installation surcharge from the installer' : ''"
            ></wb-designer-question-hardware-handle-with-suite>

          <hallmark-designer-question-bar-handle-position
            :fabricator="fabricator"
            v-model:target="door.attr.hardware_bar_handle_position"
            :hardware-handle="door.attr.hardware_handle"
            :slab="door.attr.slab"
          ></hallmark-designer-question-bar-handle-position>

            <designer-question-hardware-handle-split-spindle v-show="technical_should_show" :fabricator="fabricator"
                                                             v-model:target="door.attr.hardware_handle_split_spindle"
                                                             :hardware-handle="door.attr.hardware_handle"
                                                             :opening-direction="door.attr.opening_direction"
                                                             :type-range="door.attr.door_range"
                                                             :slab="door.attr.slab"></designer-question-hardware-handle-split-spindle>

            <designer-question-hardware-handle-internal :fabricator="fabricator"
                                                        v-model:target="door.attr.hardware_handle_internal"
                                                        :slab="door.attr.slab"
                                                        :secured-by-design="door.attr.secured_by_design"
                                                        :opening-direction="door.attr.opening_direction"
                                                        :hardware-colour="door.attr.hardware_colour"
                                                        :door-range="door.attr.door_range"
                                                        :profile="door.attr.profile"
                                                        :handle-external="door.attr.hardware_handle"></designer-question-hardware-handle-internal>

            <div v-if="!is_firedoorrange && !is_inspirationsrange && door.attr.door_range !== 132">
                <designer-question-hardware-decorative-handle :fabricator="fabricator"
                                                              v-model:target="door.attr.hardware_decorative_handle"
                                                              :slab="door.attr.slab"
                                                              :hardware-colour="door.attr.hardware_colour"
                                                              :door-range="door.attr.door_range"></designer-question-hardware-decorative-handle>

                <designer-question-hardware-decorative-handle-position :fabricator="fabricator"
                                                                       v-model:target="door.attr.hardware_decorative_handle_pos"
                                                                       :slab="door.attr.slab"
                                                                       :frame-material="door.attr.frame_material"
                                                                       :hardware-decorative-handle="door.attr.hardware_decorative_handle"></designer-question-hardware-decorative-handle-position>
            </div>
        </div>
        <div v-if="door.attr.door_range !== 132">
            <wb-designer-question-hardware-escutcheon :fabricator="fabricator"
                                                      v-model:target="door.attr.hardware_escutcheon"
                                                      :slab="door.attr.slab"
                                                      :secured-by-design="door.attr.secured_by_design"
                                                      :hardware-colour="door.attr.hardware_colour"
                                                      :hardware-handle="door.attr.hardware_handle"
                                                      :hardware-handle-internal="door.attr.hardware_handle_internal"
                                                      :door-range="door.attr.door_range"
                                                      :profile="door.attr.profile"></wb-designer-question-hardware-escutcheon>

            <designer-question-hardware-escutcheon-position :fabricator="fabricator"
                                                            v-model:target="door.attr.hardware_escutcheon_pos"
                                                            :slab="door.attr.slab"
                                                            :frame-material="door.attr.frame_material"
                                                            :hardware-escutcheon="door.attr.hardware_escutcheon"></designer-question-hardware-escutcheon-position>
        </div>

        <div v-if="is_stable">
          <wb-designer-question-hardware-escutcheon-stable :fabricator="fabricator"
                                                           title="Stable Bottom Leaf Escutcheon"
                                                           v-model:target="door.attr.hardware_escutcheon_stable"
                                                           :slab="door.attr.slab"
                                                           :secured-by-design="door.attr.secured_by_design"
                                                           :hardware-colour="door.attr.hardware_colour"
                                                           :hardware-handle="door.attr.hardware_handle"
                                                           :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                           :door-range="door.attr.door_range"></wb-designer-question-hardware-escutcheon-stable>

          <wb-designer-question-hardware-escutcheon-stable-position :fabricator="fabricator"
                                                                    v-model:target="door.attr.hardware_escutcheon_stable_pos"
                                                                    :slab="door.attr.slab"
                                                                    :frame-material="door.attr.frame_material"
                                                                    :hardware-escutcheon="door.attr.hardware_escutcheon_stable"
                                                                    :door-range="door.attr.door_range"></wb-designer-question-hardware-escutcheon-stable-position>
        </div>

        <div v-if="!panel_designer && !is_expressrange" v-show="technical_should_show">
            <designer-question-hardware-lock :fabricator="fabricator"
                                             v-model:target="door.attr.hardware_lock"
                                             :secured-by-design="door.attr.secured_by_design"
                                             :hinge-side="door.attr.hinge_side"
                                             :slab="door.attr.slab"
                                             :frame-material="door.attr.frame_material"
                                             :hardware-handle="door.attr.hardware_handle"
                                             :opening_direction="door.attr.opening_direction"
                                             :hardware-escutcheon="door.attr.hardware_escutcheon"
                                             :door-range="door.attr.door_range"
                                             :maintitle="'Choose Your Lock'"
                                             :extra_html="hardware_lock_extra_html"
            ></designer-question-hardware-lock>

            <hallmark-designer-question-hardware-cylinder v-show="technical_should_show" :fabricator="fabricator"
                                                          title="Choose Your Cylinder"
                                                          :slab="door.attr.slab"
                                                          v-model:target="door.attr.hardware_cylinder"
                                                          :secured-by-design="door.attr.secured_by_design"
                                                          :hardware-lock="door.attr.hardware_lock"
                                                          :hardware-colour="door.attr.hardware_colour"
                                                          :opening_direction="door.attr.opening_direction"
                                                          :hardware-handle="door.attr.hardware_handle"
                                                          :collection="door.attr.collection"
                                                          :door-range="door.attr.door_range"
                                                          :floating_sidebar_message="(!is_firedoorrange && !is_stable && !panel_designer && !mdd) ? '3* cylinders for high security anti bump, pick & snap' : ''"
            ></hallmark-designer-question-hardware-cylinder>

          <div v-if="is_stable">
            <wb-designer-question-hardware-cylinder-stable v-show="technical_should_show" :fabricator="fabricator"
                                                           title="Stable Bottom Leaf Cylinder"
                                                           v-model:target="door.attr.hardware_cylinder_stable"
                                                           :slab="door.attr.slab"
                                                           :secured-by-design="door.attr.secured_by_design"
                                                           :hardware-lock="door.attr.hardware_lock"
                                                           :hardware-colour="door.attr.hardware_colour"
                                                           :hardware-handle="door.attr.hardware_handle"
                                                           :hardware-cylinder="door.attr.hardware_cylinder"
                                                           :door-range="door.attr.door_range"></wb-designer-question-hardware-cylinder-stable>

            <wb-designer-question-hardware-joining-bolt :fabricator="fabricator"
                                                        title="Choose your Rack Bolt"
                                                        v-model:target="door.attr.hardware_joining_bolt"
                                                        :slab="door.attr.slab"
                                                        :door-range="door.attr.door_range"></wb-designer-question-hardware-joining-bolt>

            <wb-designer-question-hardware-joining-bolt-position :fabricator="fabricator"
                                                                 v-model:target="door.attr.hardware_joining_bolt_pos"
                                                                 :slab="door.attr.slab"
                                                                 :frame-material="door.attr.frame_material"
                                                                 :hardware-joining-bolt="door.attr.hardware_joining_bolt"
                                                                 :door-range="door.attr.door_range"></wb-designer-question-hardware-joining-bolt-position>
          </div>

            <designer-question-hardware-key
                v-if="!is_double_rebate_range"
                v-show="technical_should_show"
                :fabricator="fabricator"
                title="Extra Key Type"
                v-model:target="door.attr.key"
                :hardware-cylinder="door.attr.hardware_cylinder"
            ></designer-question-hardware-key>

            <hallmark-designer-question-hardware-key-qty
              v-if="!is_double_rebate_range"
              v-show="technical_should_show"
              :fabricator="fabricator"
              v-model:target="door.attr.key_qty"
              :keyAttribute="door.attr.key"
              :floating_sidebar_message="(!is_firedoorrange && !is_stable && !panel_designer && !mdd) ? 'Save your customer money when ordering additional keys with the door' : ''"
            ></hallmark-designer-question-hardware-key-qty>

        </div>

        <div v-if="door.attr.door_range !== 132">
            <wb-designer-question-hardware-letterbox :fabricator="fabricator"
                                                     v-model:target="door.attr.hardware_letterbox"
                                                     :secured-by-design="door.attr.secured_by_design"
                                                     :slab="door.attr.slab"
                                                     :side-panels="door.attr.side_panels"
                                                     :frame-id="door.attr.frame_style.frame_id"
                                                     :hardware-handle="door.attr.hardware_handle"
                                                     :hardware-colour="door.attr.hardware_colour"
                                                     :door-range="door.attr.door_range"></wb-designer-question-hardware-letterbox>

            <designer-question-hardware-letterbox-cowl :fabricator="fabricator"
                                                       v-model:target="door.attr.hardware_letterbox_cowl"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :hardware-letterplate="door.attr.hardware_letterbox"
                                                       :hardware-colour="door.attr.hardware_colour"></designer-question-hardware-letterbox-cowl>

            <designer-question-hardware-letterbox-position :fabricator="fabricator"
                                                           v-model:target="door.attr.hardware_letterbox_pos"
                                                           :slab="door.attr.slab"
                                                           :side-panels="door.attr.side_panels"
                                                           :frame-id="door.attr.frame_style.frame_id"
                                                           :frame-material="door.attr.frame_material"
                                                           :hardware-letterbox="door.attr.hardware_letterbox"></designer-question-hardware-letterbox-position>
        </div>
        <div v-if="door.attr.door_range !== 132">
            <wb-designer-question-hardware-knocker :fabricator="fabricator"
                                                   v-model:target="door.attr.hardware_knocker"
                                                   :slab="door.attr.slab"
                                                   :hardware-handle="door.attr.hardware_handle"
                                                   :hardware-spyhole="door.attr.hardware_spy_hole"
                                                   :hardware-colour="door.attr.hardware_colour"
                                                   :door-range="door.attr.door_range"
                                                   :floating_sidebar_message="(!is_firedoorrange && !is_stable && !panel_designer && !mdd) ? 'Can’t find the knocker you require? Knockers are suited to match handles/letterplates. We can provide unsuited if required.' : ''"
            ></wb-designer-question-hardware-knocker>

            <designer-question-hardware-knocker-position :fabricator="fabricator"
                                                         v-model:target="door.attr.hardware_knocker_pos"
                                                         :slab="door.attr.slab"
                                                         :frame-material="door.attr.frame_material"
                                                         :hardware-knocker="door.attr.hardware_knocker"></designer-question-hardware-knocker-position>
        </div>
        <div v-if="door.attr.door_range !== 132">
            <wb-designer-question-hardware-spy-hole :fabricator="fabricator"
                                                    v-model:target="door.attr.hardware_spy_hole"
                                                    :slab="door.attr.slab"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :glass-design="door.attr.glass_design"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :hardware-knocker="door.attr.hardware_knocker"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :door-range="door.attr.door_range"></wb-designer-question-hardware-spy-hole>

            <designer-question-hardware-spy-hole-position :fabricator="fabricator"
                                                          v-model:target="door.attr.hardware_spy_hole_pos"
                                                          :slab="door.attr.slab"
                                                          :frame-material="door.attr.frame_material"
                                                          :hardware-spy-hole="door.attr.hardware_spy_hole"></designer-question-hardware-spy-hole-position>
        </div>
        <div class="designeroption" v-show="technical_should_show && !is_expressrange && door.attr.door_range !== 132" data-designer-component-id="numerals">
            <designer-question-hardware-numerals :fabricator="fabricator"
                                                 v-model:target="door.attr.numerals"
                                                 :slab="door.attr.slab"
                                                 :hardware-handle="door.attr.hardware_handle"
                                                 :hardware-colour="door.attr.hardware_colour"
                                                 title="Numerals"></designer-question-hardware-numerals>
        </div>

        <div v-show="technical_should_show && !panel_designer && !is_expressrange">
            <designer-question-hinge-qty
              :fabricator="fabricator"
              :type-range="door.attr.door_range"
              v-model:target="door.attr.hinge_qty"
            ></designer-question-hinge-qty>

            <wb-designer-question-hardware-hinge :fabricator="fabricator"
                                                 v-model:target="door.attr.hardware_hinge"
                                                 :slab="door.attr.slab"
                                                 :opening_direction="door.attr.opening_direction"
                                                 :secured-by-design="door.attr.secured_by_design"
                                                 :hardware-colour="door.attr.hardware_colour"
                                                 :hinge-side="door.attr.hinge_side"
                                                 :frame-material="door.attr.frame_material"
                                                 :door-range="door.attr.door_range"
                                                 :hinge-qty="door.attr.hinge_qty"
                                                 :floating_sidebar_message="(!is_firedoorrange && !is_stable && !panel_designer && !mdd) ? 'Height adjustable hinges available to help you when installing<br><br>Hinge Clearance<br>Haven - 30mm<br>SFS 2D-C - 42mm<br>SFS 2D-F - 30mm\n' : ''"
            ></wb-designer-question-hardware-hinge>

            <div class="designeroption">
                <hallmark-designer-question-hardware-hinge-bolts v-if="!is_firedoorrange && !is_inspirationsrange"
                                                                 :fabricator="fabricator"
                                                                 v-model:target="door.attr.hardware_hinge_bolts"
                                                                 :hardware-hinge="door.attr.hardware_hinge"
                                                                 :secured-by-design="door.attr.secured_by_design"
                                                                 :hardware-colour="door.attr.hardware_colour"></hallmark-designer-question-hardware-hinge-bolts>
            </div>

        </div>

        <div v-if="!panel_designer && !is_expressrange">
            <designer-question-hardware-security-chain :fabricator="fabricator"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       v-model:target="door.attr.hardware_security_chain"
                                                       :hardware-colour="door.attr.hardware_colour"
                                                       :door-range="door.attr.door_range"></designer-question-hardware-security-chain>
        </div>

        <div class="designeroption" v-if="!panel_designer && !is_expressrange">
            <h3>Door Extras</h3>
            <div class="designer-floating-sidebar-message" v-if="!is_firedoorrange && !is_stable && !panel_designer && !mdd">
                <i class="fa fa-circle-question"></i>
                To help you when installing doors
            </div>
            <designer-question-collection-option :fabricator="fabricator"
                                                 v-model:target="door.attr.touch_up_kit"
                                                 :question="'touch_up_kit'"
                                                 :title="'Touch Up Kit'"
                                                 :fabricator_name="'hallmark'"
            ></designer-question-collection-option>
            <designer-question-collection-option :fabricator="fabricator"
                                                 v-model:target="door.attr.door_bell"
                                                 :question="'door_bell'"
                                                 :title="'Door Bell'"
                                                 :fabricator_name="'hallmark'"
            ></designer-question-collection-option>
            <div class="designer-floating-sidebar-message" v-if="!is_firedoorrange && !is_stable && !panel_designer && !mdd">
                <i class="fa fa-circle-question"></i>
                Ideal for spraying trims etc
            </div>
            <designer-question-collection-option :fabricator="fabricator"
                                                 v-model:target="door.attr.matching_paint"
                                                 :question="'matching_paint'"
                                                 :title="'Matching Paint Aerosol Can'"
                                                 :fabricator_name="'hallmark'"
            ></designer-question-collection-option>
            <designer-question-collection-option :fabricator="fabricator"
                                                 v-model:target="door.attr.hinge_spanner"
                                                 :question="'hinge_spanner'"
                                                 :title="'SFS Hinge Adjustment Spanner'"
                                                 :fabricator_name="'hallmark'"
                                                 :hardware-hinge="door.attr.hardware_hinge"
            ></designer-question-collection-option>

            <designer-question-collection-option
                v-show="!this.is_firedoorrange"
                :fabricator="fabricator"
                v-model:target="door.attr.door_stop"
                :question="'door_stop'"
                :title="'Door Stop'"
                :fabricator_name="'hallmark'"
            ></designer-question-collection-option>

            <designer-question-collection-option
                v-show="!this.is_firedoorrange"
                :fabricator="fabricator"
                v-model:target="door.attr.keyring"
                :question="'keyring'"
                :title="'Keyring'"
                :fabricator_name="'hallmark'"
            ></designer-question-collection-option>

            <designer-question-collection-option
                v-if="is_firedoorrange"
                :fabricator="fabricator"
                v-model:target="door.attr.fd_sticker"
                :question="'fd_sticker'"
                :title="'Fire Door Sticker'"
                :fabricator_name="'hallmark'"
            ></designer-question-collection-option>
        </div>

        <div>
            <designer-question-closer
                v-show="!panel_designer && !slab_only"
                :fabricator="fabricator"
                :type-range="door.attr.door_range"
                maintitle="Choose Closer"
                v-model:target="door.attr.closer"
            ></designer-question-closer>
        </div>

        <div v-show="technical_should_show && !is_expressrange && !panel_designer && !slab_only">
            <designer-question-technical-profile :fabricator="fabricator"
                                                 :frame-colour-internal="door.attr.frame_colour_internal"
                                                 :frame-colour-external="door.attr.frame_colour_external"
                                                 :frame-material="door.attr.frame_material"
                                                 :secured-by-design="door.attr.secured_by_design"
                                                 :hardware-handle="door.attr.hardware_handle"
                                                 :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                 :opening-direction="door.attr.opening_direction"
                                                 v-model:target="door.attr.profile"
                                                 :maintitle="'Select your frame profile & size'"
                                                 :title="''"
                                                 :floating_sidebar_message="floating_sidebar_message_for_profile"
                                                 :door-range="door.attr.door_range"
            ></designer-question-technical-profile>
        </div>

        <div class="designeroption" v-if="is_firedoorrange">
            <designer-question-fitting-kit v-show="technical_should_show" :fabricator="fabricator"
                                           v-model:target="door.attr.fitting_pack">

            </designer-question-fitting-kit>
        </div>

        <template v-if="!panel_designer && !slab_only">
            <div v-if="is_firedoorrange" v-show="technical_should_show">
                <hallmark-designer-question-addons :fabricator="fabricator"
                                                   v-model:target="door.attr.addons"
                                                   :frame-profile="door.attr.profile"
                                                   :frame-colour-internal="door.attr.frame_colour_internal"
                                                   :frame-colour-external="door.attr.frame_colour_external">

                </hallmark-designer-question-addons>
            </div>
            <div v-else v-show="technical_should_show && !is_expressrange">
                <wb-designer-question-addons :fabricator="fabricator"
                                             v-model:target="door.attr.addons"
                                             :frame-profile="door.attr.profile"
                                             :frame-colour-internal="door.attr.frame_colour_internal"
                                             :frame-colour-external="door.attr.frame_colour_external">

                </wb-designer-question-addons>
            </div>

            <div v-show="technical_should_show && !is_expressrange">
                <wb-designer-question-technical-threshold :fabricator="fabricator"
                                                          title="Choose Your Threshold"
                                                          v-model:target="door.attr.threshold"
                                                          :frame-colour-internal="door.attr.frame_colour_internal"
                                                          :frame-colour-external="door.attr.frame_colour_external"
                                                          :opening-direction="door.attr.opening_direction"
                                                          :frame-profile="door.attr.profile"
                                                          :door-range="door.attr.door_range"
                                                          :secured-by-design="door.attr.secured_by_design"
                                                          extra_text="Detailed views available <a href='https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/8/hallmark_threshold_cross_sections.pdf' target='_blank'>here (click to open)</a>."
                                                          :floating_sidebar_message="(!is_firedoorrange && !is_stable && !panel_designer && !mdd) ? 'MXS15 is lowest threshold. MDS70 can be removed once door is fitted (25mm)' : ''"
                ></wb-designer-question-technical-threshold>

            </div>

            <div class="designeroption" v-show="technical_should_show && !is_expressrange">
                <h3>Select Any Required Cills</h3>
                <designer-question-technical-cill :fabricator="fabricator"
                                                  v-model:target="door.attr.cill"
                                                  :frame-colour-internal="door.attr.frame_colour_internal"
                                                  :frame-colour-external="door.attr.frame_colour_external"
                                                  :opening-direction="door.attr.opening_direction"
                                                  :frame-profile="door.attr.profile"
                                                  :door-range="door.attr.door_range"
                                                  :threshold="door.attr.threshold"
                                                  :component_id="'cill'"
                ></designer-question-technical-cill>

                <designer-question-technical-cill v-if="left_flag_sill" :fabricator="fabricator"
                                                  v-model:target="door.attr.side_panels.left_flag_sill_id"
                                                  :frame-colour-internal="door.attr.frame_colour_internal"
                                                  :frame-colour-external="door.attr.frame_colour_external"
                                                  :frame-profile="door.attr.profile"
                                                  :title="'Left Sidepanel Flag'"
                                                  :component_id="'left_flag_cill'"
                ></designer-question-technical-cill>

                <designer-question-technical-cill v-if="right_flag_sill" :fabricator="fabricator"
                                                  v-model:target="door.attr.side_panels.right_flag_sill_id"
                                                  :frame-colour-internal="door.attr.frame_colour_internal"
                                                  :frame-colour-external="door.attr.frame_colour_external"
                                                  :frame-profile="door.attr.profile"
                                                  :title="'Right Sidepanel Flag'"
                                                  :component_id="'right_flag_cill'"
                ></designer-question-technical-cill>
            </div>
        </template>

        <div v-show="!is_expressrange && !panel_designer">
            <wb-designer-question-door-drip-colour v-show="technical_should_show" :fabricator="fabricator"
                                                   title="Choose A Door Drip colour"
                                                   :external-colour="door.attr.external_colour"
                                                   v-model:target="door.attr.door_drip_colour"
                                                   :frame-profile="door.attr.profile"
                                                   :door-range="door.attr.door_range"></wb-designer-question-door-drip-colour>
        </div>

        <div v-if="is_stable">
            <div class="designeroption" data-designer-component-id="meeting_bar_style">
                <h3>Select Your Stable Meeting Styles</h3>
                <div class="stylesoption">
                    <div class="row">
                        <div class="col-md">
                            <designer-question-meeting-rail-colour
                                :fabricator="fabricator"
                                title="Bottom Meeting Style (Outside)"
                                :door-colour="door.attr.external_colour"
                                v-model:target="door.attr.meeting_bar_outside"
                                :frame-profile="door.attr.profile"
                            ></designer-question-meeting-rail-colour>
                        </div>
                        <div class="col-md">
                            <designer-question-meeting-rail-colour
                                :fabricator="fabricator"
                                title="Top Meeting Style (Inside)"
                                :door-colour="door.attr.door_colour_internal"
                                v-model:target="door.attr.meeting_bar_inside"
                                :frame-profile="door.attr.profile"
                                :meeting-rail-outside="door.attr.meeting_bar_outside"
                            ></designer-question-meeting-rail-colour>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!panel_designer" v-show="technical_should_show && !is_expressrange && !slab_only">
            <hallmark-designer-question-technical-drainage
                :fabricator="fabricator"
                v-model:target="door.attr.drainage"
                :cill="door.attr.cill"
                :threshold="door.attr.threshold"
                title="Choose your Drainage type (Standard = Hallmark Chooses suitable option)"
            ></hallmark-designer-question-technical-drainage>
        </div>

      <div class="designeroption hallmark-designer-express-features-box" v-if="is_expressrange">
        <h3>What's included?</h3>
        <div class="stylesoption designer-question-tiled-layout _2-col" v-if="door.attr.slab === 2401">
          <div class="tile">
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              <strong>Mulsanne 1</strong>
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              White/White Frame
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              White/White Door
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              Satin Glass
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              890mm x 2090mm Composite Door
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              150mm Cill Inc Dimensions
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              Open in
            </div>
          </div>
          <div class="tile">
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              Chrome handle
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              Key/thumbturn cylinder
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              x3 White haven hinges
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              72mm Rustique - Sculptured Frame
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              MDS70 Threshold Low Ali (25mm high)
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              Colour matched drip bar
            </div>
          </div>
        </div>
        <div class="stylesoption designer-question-tiled-layout _2-col" v-if="door.attr.slab === 2400">
          <div class="tile">
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              <strong>Esprit 2</strong>
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              White/White Frame
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              Anthracite/White Door
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              Satin Glass
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              890mm x 2090mm Composite Door
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              150mm Cill Inc Dimensions
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              Open in
            </div>
          </div>
          <div class="tile">
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              Chrome hardware
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              Chrome letterplate
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              Key/thumbturn cylinder
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              x3 White haven hinges
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              72mm Rustique - Sculptured Frame
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              MDS70 Threshold Low Ali (25mm high)
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              Colour matched drip bar
            </div>
          </div>
        </div>
        <div class="stylesoption designer-question-tiled-layout _2-col" v-if="door.attr.slab === 2402">
          <div class="tile">
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              <strong> Flush Solid</strong>
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              White/White Frame
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              Anthracite/White Door
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              890mm x 2090mm Composite Door
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              150mm Cill Inc Dimensions
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              Open in
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              Chrome hardware
            </div>
          </div>
          <div class="tile">
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              Key/thumbturn cylinder
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              x3 White haven hinges
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              72mm Rustique - Sculptured Frame
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              MDS70 Threshold Low Ali (25mm high)
            </div>
            <div class="pb-1">
              <i class="fa fa-check pr-1"></i>
              Colour matched drip bar
            </div>
          </div>
        </div>
      </div>

      <hallmark-designer-question-cut-to-size
        v-if="panel_designer"
        :fabricator="fabricator"
        :panel-category="door.attr.panel_category"
        v-model:target="door.attr.cut_to_size"
      ></hallmark-designer-question-cut-to-size>

      <div v-show="!creating_predesigned_door && ((technical_should_show && !panel_designer && !is_expressrange) || (panel_designer && door.attr.cut_to_size == 64))">
        <hallmark-designer-question-measurements title="Enter Your Required Measurements"
                                                 :fabricator="fabricator"
                                                 :slab="door.attr.slab"
                                                 :external-colour="door.attr.external_colour"
                                                 :internal-colour="door.attr.door_colour_internal"
                                                 :frame-profile="door.attr.profile"
                                                 :threshold="door.attr.threshold"
                                                 :frame-id="door.attr.frame_style.frame_id"
                                                 :side-panels="door.attr.side_panels"
                                                 :addons="door.attr.addons"
                                                 :cill="door.attr.cill"
                                                 :hardware-lock="door.attr.hardware_lock"
                                                 :hardware-hinge="door.attr.hardware_hinge"
                                                 :hardware-handle="door.attr.hardware_handle"
                                                 :hardware-handle-internal="door.attr.hardware_handle_internal"
                                                 :hardware-knocker="door.attr.hardware_knocker"
                                                 :hardware-spy-hole="door.attr.hardware_spy_hole"
                                                 :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                 :hardware-letterbox="door.attr.hardware_letterbox"
                                                 :hardware-letterbox-position="door.attr.hardware_letterbox_pos"
                                                 v-model:target="door.attr.measurements"
                                                 :extra_text="measurements_extra_text"
                                                 :cut-to-size="!panel_designer || (panel_designer && door.attr.cut_to_size == 64)"
                                                 :panel-designer="panel_designer"
                                                 :mdd="mdd"
                                                 :floating_sidebar_message="(!is_firedoorrange && !is_stable && !panel_designer && !mdd) ? 'Cills, addons and thresholds are included in your overall width and height' : ''"
        ></hallmark-designer-question-measurements>
      </div>

      <designer-question-match-previous-or-future-project
        v-if="!mdd && (composite_door_designer || is_firedoorrange)"
        v-model:match_project="door.attr.match_previous_or_future_project"
        v-model:target="door.attr.match_previous_or_future_project_number"
      ></designer-question-match-previous-or-future-project>

      <template v-if="creating_predesigned_door">
        <input dusk="door_reference" type="hidden" v-model="door.attr.reference" value="Predesigned Door">
      </template>
      <template v-else>
        <div class="designeroption" v-if="reference_on" data-designer-component-id="reference">
          <h3>Enter A Door Reference</h3>
          <div class="stylesoption">
            <div class="form-group">
              <input dusk="door_reference" type="text" v-model="door.attr.reference" class="form-control">
            </div>
          </div>
        </div>
        <input v-else dusk="door_reference" type="hidden" v-model="door.attr.reference" class="form-control"
               value="Retail Door">
      </template>

      <designer-question-notes v-show="!is_expressrange" v-model:target="door.attr.notes" :placeholder="notes_placeholder"></designer-question-notes>

        <div class="designeroption">
            <div class="stylesoption">
                <div class="txt-sm">
                    Due to fast lead times please ensure that order is final when placing, amendments may not be available if production has already started. Images are for illustration purposes only and are not to scale. Colours may vary significantly from screen to screen. It is recommended you refer to physical samples. <em>* Working days only, subject to door slab availability.</em>
                </div>
            </div>
        </div>

      <a class="hallmark-live-chat-link _on-designer" href="https://direct.lc.chat/14722584/" target="_blank" v-if="!mdd">
        <img :src="'/images/hallmark/live-chat-link.png'">
        <div>
          Need Help?<br/>
          Click Here For Live Chat<br/>
          Or Call 01482 781 111<br/>
          Mon-Fri 9-5
        </div>
      </a>

        <designer-navigation
                v-if="show_navigation"
                :visible_designer_configurator_components="visible_designer_configurator_components"
                transition="designer-navigation"
        ></designer-navigation>

    </div>

</template>

<script type="text/ecmascript-6">
    import DoorConfigurator from "../DoorConfigurator.vue";

    export default {
        mixins: [
            DoorConfigurator,
        ],
        computed: {
            composite_door_designer() {
              return [26,27,28,45,67,68,118].includes(this.door.attr.door_range);
            },
            panel_designer() {
              return this.door.attr.door_range === 128 || this.door.attr.door_range === 129 || this.door.attr.door_range === 130 || this.door.attr.door_range === 131 || this.door.attr.door_range === 132 || this.door.attr.door_range === 133;
            },
            is_firedoorrange() {
                return this.door_type === 'fire';
            },
            is_inspirationsrange() {
                return this.door.attr.door_range === 45;
            },
            is_expressrange() {
              return this.door.attr.door_range === 148;
            },
            is_double_rebate_range() {
                return this.door.attr.door_range === 165;
            },
            is_stable(){
              return this.door_type === 'stable';
            },
            slab_only() {
                return this.door.attr.frame_material === 99 && !this.panel_designer;
            },
            suites() {
                if (this.door_type === 'fire') {
                    return '10';
                } else if(this.panel_designer) {
                    return '67';
                } else if(this.is_stable) {
                    return '90';
                } else {
                    return '58,8,5,76,84';
                }
            },
            signature_deluxe() {
                return this.door.attr.collection === 2;
            },
            measurements_extra_text() {
              if(!this.is_firedoorrange && !this.panel_designer && !this.mdd) {
                return "Cottage doors can be manufactured from 680mm wide please contact customer service for more information. The undersize cottage slabs for narrower doors only come in white. Therefore there is a spray surcharge for all colours that will be added after ordering.";
              }
              return '';
            },
            notes_placeholder() {
              if(!this.mdd) {
                return `Please do not enter a delivery address here, the option is available at checkout. \n\nPlease consider whether it is essential to write anything in the notes section. We use an automated processing system. Writing notes may potentially slow down your order as it will need to be manually processed.`;
              }
              return "";
            },
          hardware_lock_extra_html() {
              if(this.is_stable) {
                return "";
              } else {
                return `<div class='mt-3'>
                            <strong>NEW: What Is The Winkhaus AV4 Lock?</strong>
                            <ul>
                              <li>Reduced operational force (DDA Friendly)</li>
                              <li>Increased Operational Tolerances</li>
                              <li>Non-Handed</li>
                              <li>PAS24:2022 Compliant</li>
                              <li>Optional Day/Night Latch</li>
                              <li>Slam Shut Lock</li>
                              <li>Easier to open</li>
                            </ul>
                         <div><a href='https://www.winkhaus.co.uk/en/autolock-av4' target='_blank'>To find out more click here: https://www.winkhaus.co.uk/en/autolock-av4</a></div>
                       </div>`
              }
          },
            floating_sidebar_message_for_profile() {
                if (this.is_firedoorrange || this.is_stable || this.panel_designer || this.mdd) {
                    return "";
                } else if (this.is_double_rebate_range) {
                    return `<a href='https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/8/hallmark-frame-cross-section-for-sidebar-message-72-only.png' target='_blank'>Click here for image of frame cross section</a>`;
                } else {
                    return `Switch to 56mm outer frame to get narrow widths<br><br><a href='https://tranquility-dev.s3.eu-west-2.amazonaws.com/fabricator_uploads/8/hallmark-frame-cross-section-for-sidebar-message.png' target='_blank'>Click here for image of frame cross section</a>`;
                }
            },
        },
        methods: {
            defaults() {
                return {
                    26: {
                        "attr": {
                            "fabricator": 8,
                            "door_range": 26,
                            "type": 1,
                            "frame_colour_external": 1,
                            "colour_range": 5,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "hardware_colour": 22,
                            "hardware_handle": 1051,
                            "hardware_hinge": 370,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 8,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "argon_glass": 27,
                            "hardware_lock": 167,
                            "hardware_cylinder": 837,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_suite": 8,
                            "hardware_spy_hole": 316,
                            "profile": 7856,
                            "threshold": 7854,
                            "side_panels": {
                                "left": 1,
                                "right": 1,
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "side_glass_text": {"text": "", "position": null},
                                "lower_sidepanel_type": 19
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {"left": {}, "right": {}, "top": {}, "bottom": {}},
                            "cill": 149,
                            "drainage": 2,
                            "notes": "",
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null
                            },
                            "hardware_hinge_bolts": 754,
                            "hardware_handle_split_spindle": 424,
                            "hardware_decorative_handle": 1112,
                            "collection": 1,
                            "touch_up_kit": 6,
                            "matching_paint": 11,
                            "trickle_vents": 1721,
                            "hinge_qty": 25,
                            "match_previous_or_future_project": 77,
                            "match_previous_or_future_project_number": null,
                            "hinge_spanner": 79,
                            "closer": 598,
                            "door_stop": 84,
                            "keyring": 86,
                        }
                    },
                    27: {
                        "attr": {
                            "fabricator": 8,
                            "door_range": 27,
                            "type": 1,
                            "colour_range": 5,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "hardware_colour": 22,
                            "hardware_handle": 1051,
                            "hardware_hinge": 370,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "argon_glass": 27,
                            "hardware_lock": 167,
                            "hardware_cylinder": 837,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_suite": 8,
                            "hardware_spy_hole": 316,
                            "profile": 7856,
                            "threshold": 7854,
                            "side_panels": {
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "left": 1,
                                "right": 1,
                                "side_glass_text": {"text": "", "position": null},
                                "lower_sidepanel_type": 19
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 2,
                            "notes": "",
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                            "slab": 234,
                            "frame_material": 1,
                            "glass_design": 1,
                            "hardware_hinge_bolts": 754,
                            "hardware_handle_split_spindle": 424,
                            "hardware_decorative_handle": 1112,
                            "collection": 1,
                            "touch_up_kit": 6,
                            "matching_paint": 11,
                            "trickle_vents": 1721,
                            "hinge_qty": 25,
                            "slab_cassette": 573,
                            "match_previous_or_future_project": 77,
                            "match_previous_or_future_project_number": null,
                            "hinge_spanner": 79,
                            "door_stop": 84,
                            "keyring": 86,
                        }
                    },
                    28: {
                        "attr": {
                            "fabricator": 8,
                            "door_range": 28,
                            "type": 1,
                            "colour_range": 5,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "hardware_colour": 22,
                            "hardware_handle": 1051,
                            "hardware_hinge": 370,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "argon_glass": 27,
                            "hardware_lock": 167,
                            "hardware_cylinder": 837,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_suite": 8,
                            "hardware_spy_hole": 316,
                            "profile": 7856,
                            "threshold": 7854,
                            "side_panels": {
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "left": 1,
                                "right": 1,
                                "side_glass_text": {"text": "", "position": null},
                                "lower_sidepanel_type": 19
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "notes": "",
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                            "slab": 27,
                            "frame_material": 1,
                            "glass_design": 1,
                            "hardware_hinge_bolts": 754,
                            "hardware_handle_split_spindle": 424,
                            "hardware_decorative_handle": 1112,
                            "collection": 1,
                            "touch_up_kit": 6,
                            "matching_paint": 11,
                            "trickle_vents": 1721,
                            "hinge_qty": 25,
                            "slab_cassette": 561,
                            "match_previous_or_future_project": 77,
                            "match_previous_or_future_project_number": null,
                            "hinge_spanner": 79,
                            "door_stop": 84,
                            "keyring": 86,
                        }
                    },
                    29: {
                        "attr": {
                            "addons": {"left": {}, "right": {}, "top": {}, "bottom": {}},
                            "cill": 149,
                            "closer": 3932,
                            "door_range": 29,
                            "type": 6,
                            "colour_range": 5,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "drainage": 1,
                            "external_colour": 1,
                            "fabricator": 8,
                            "fitting_pack": 2136,
                            "frame_colour_external": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 3,
                            "frame_style": {"frame_id": 31, "checkedPanels": []},
                            "glass_text": "",
                            "hardware_handle": 3924,
                            "hardware_hinge": 1100,
                            "hinge_side": 1,
                            "hardware_lock": 396,
                            "hardware_colour": 22,
                            "hardware_cylinder": 3928,
                            "hardware_hinge_bolts": 754,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_security_chain": 3921,
                            "hardware_spy_hole": 918,
                            "hardware_suite": 10,
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null
                            },
                            "notes": "",
                            "numerals": [326, 326, 326, 326],
                            "opening_direction": 1,
                            "profile": 4221,
                            "secured_by_design": 2,
                            "side_panels": {
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "left_panel_glass_id": 313,
                                "right_panel_glass_id": 313,
                                "top_panel_glass_id": 24,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left": 52,
                                "right": 52,
                                "side_glass_text": {"text": "", "position": null},
                                "lower_sidepanel_type": 19
                            },
                            "slab": 454,
                            "threshold": 8384,
                            "hardware_spy_hole_pos": 11827,
                            "collection": 1,
                            "touch_up_kit": 6,
                            "door_bell": 8,
                            "matching_paint": 11,
                            "trickle_vents": 1721,
                            "hinge_qty": 25,
                            "hinge_spanner": 79,
                            "door_stop": 84,
                            "keyring": 86,
                            "argon_glass": 27,
                            "fd_sticker": 98,
                        }
                    },
                    45: {
                        "attr": {
                            "fabricator": 8,
                            "door_range": 45,
                            "type": 1,
                            "colour_range": 5,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_text": "",
                            "hardware_colour": 22,
                            "hardware_handle": 1051,
                            "hardware_hinge": 370,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 8,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "argon_glass": 27,
                            "hardware_lock": 167,
                            "hardware_cylinder": 837,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_suite": 8,
                            "hardware_spy_hole": 316,
                            "profile": 8011,
                            "threshold": 8018,
                            "side_panels": {
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "left_panel_glass_id": 9,
                                "right_panel_glass_id": 9,
                                "top_panel_glass_id": 9,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left": 1,
                                "right": 1,
                                "side_glass_text": {"text": "", "position": null}
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "notes": "",
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null
                            },
                            "hardware_hinge_bolts": 754,
                            "closer": 598,
                            "hardware_handle_split_spindle": 424,
                            "collection": 1,
                            "touch_up_kit": 6,
                            "door_bell": 8,
                            "matching_paint": 11,
                            "trickle_vents": 1721,
                            "hinge_qty": 25,
                            "match_previous_or_future_project": 77,
                            "match_previous_or_future_project_number": null,
                            "hinge_spanner": 79,
                            "door_stop": 84,
                            "keyring": 86,
                        }
                    },
                    67: {
                        "attr": {
                            "fabricator": 8,
                            "door_range": 67,
                            "type": 1,
                            "colour_range": 5,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 1,
                            "hardware_colour": 22,
                            "hardware_handle": 1051,
                            "hardware_hinge": 370,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 900,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "argon_glass": 27,
                            "hardware_lock": 167,
                            "hardware_cylinder": 837,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_suite": 8,
                            "hardware_spy_hole": 316,
                            "profile": 7856,
                            "threshold": 7854,
                            "side_panels": {
                                "left": 1,
                                "right": 1,
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "side_glass_text": {"text": "", "position": null},
                                "lower_sidepanel_type": 19
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 2,
                            "notes": "",
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                            "hardware_hinge_bolts": 754,
                            "hardware_handle_split_spindle": 424,
                            "hardware_escutcheon_pos": 33891,
                            "hardware_decorative_handle": 1112,
                            "collection": 1,
                            "touch_up_kit": 6,
                            "matching_paint": 11,
                            "trickle_vents": 1721,
                            "hinge_qty": 25,
                            "slab_cassette": 658,
                            "match_previous_or_future_project": 77,
                            "match_previous_or_future_project_number": null,
                            "hinge_spanner": 79,
                            "door_stop": 84,
                            "keyring": 86,
                        }
                    },
                    68: {
                        "attr": {
                            "fabricator": 8,
                            "door_range": 68,
                            "type": 1,
                            "colour_range": 5,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 1,
                            "hardware_colour": 22,
                            "hardware_handle": 1051,
                            "hardware_hinge": 370,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 1054,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "argon_glass": 27,
                            "hardware_lock": 167,
                            "hardware_cylinder": 837,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_suite": 8,
                            "hardware_spy_hole": 316,
                            "profile": 7856,
                            "threshold": 7854,
                            "side_panels": {
                                "left": 1,
                                "right": 1,
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "side_glass_text": {"text": "", "position": null},
                                "lower_sidepanel_type": 19
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 2,
                            "notes": "",
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                            "hardware_hinge_bolts": 754,
                            "hardware_handle_split_spindle": 424,
                            "hardware_escutcheon_pos": 33578,
                            "hardware_decorative_handle": 1112,
                            "collection": 1,
                            "touch_up_kit": 6,
                            "matching_paint": 11,
                            "trickle_vents": 1721,
                            "hinge_qty": 25,
                            "slab_cassette": 667,
                            "match_previous_or_future_project": 77,
                            "match_previous_or_future_project_number": null,
                            "hinge_spanner": 79,
                            "door_stop": 84,
                            "keyring": 86,
                        }
                    },
                    118: {
                        "attr": {
                            "fabricator": 8,
                            "door_range": 118,
                            "type": 1,
                            "colour_range": 5,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "glass_design": 1,
                            "hardware_colour": 22,
                            "hardware_handle": 1051,
                            "hardware_hinge": 370,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 1875,
                            "frame_style": {
                                "frame_id": 1,
                                "checkedPanels": []
                            },
                            "laminated_glass": 1,
                            "argon_glass": 27,
                            "hardware_lock": 167,
                            "hardware_cylinder": 837,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_suite": 8,
                            "hardware_spy_hole": 316,
                            "profile": 7856,
                            "threshold": 7854,
                            "side_panels": {
                                "left": 1,
                                "right": 1,
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "side_glass_text": {
                                    "text": "",
                                    "position": null
                                }
                            },
                            "numerals": [
                                326,
                                326,
                                326,
                                326
                            ],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 2,
                            "notes": "",
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null
                            },
                            "hardware_hinge_bolts": 754,
                            "hardware_handle_split_spindle": 424,
                            "hardware_escutcheon_pos": 33891,
                            "hardware_decorative_handle": 1112,
                            "collection": 1,
                            "touch_up_kit": 6,
                            "door_bell": 8,
                            "matching_paint": 11,
                            "trickle_vents": 1721,
                            "hinge_qty": 25,
                            "match_previous_or_future_project": 77,
                            "match_previous_or_future_project_number": null,
                            "hinge_spanner": 79,
                            "door_stop": 84,
                            "keyring": 86,
                        }
                    },
                    128: {
                        "attr": {
                            "fabricator": 8,
                            "door_range": 128,
                            "frame_colour_external": 1,
                            "colour_range": 5,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 99,
                            "hardware_colour": 22,
                            "hardware_handle": 1051,
                            "hardware_hinge": 370,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 1,
                            "frame_style": {"frame_id": 65, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 167,
                            "hardware_cylinder": 837,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_suite": 8,
                            "hardware_spy_hole": 316,
                            "profile": 120911,
                            "threshold": 120912,
                            "side_panels": {
                                "left": 1,
                                "right": 1,
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "side_glass_text": {"text": "", "position": null},
                                "lower_sidepanel_type": 19
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 2,
                            "notes": "",
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                            "hardware_hinge_bolts": 754,
                            "hardware_handle_split_spindle": 424,
                            "hardware_decorative_handle": 1112,
                            "collection": 1,
                            "touch_up_kit": 6,
                            "matching_paint": 11,
                            "trickle_vents": 1721,
                            "slab_cassette": 540,
                            "glass_design": 1,
                            "hinge_spanner": 79,
                        }
                    },
                    129: {
                        "attr": {
                            "fabricator": 8,
                            "door_range": 129,
                            "type": 11,
                            "frame_colour_external": 82,
                            "colour_range": 19,
                            "door_colour_internal": 1043,
                            "door_drip_colour": 82,
                            "external_colour": 1043,
                            "frame_material": 99,
                            "hardware_colour": 22,
                            "hardware_handle": 2918,
                            "hardware_hinge": 1854,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 2538,
                            "frame_style": {"frame_id": 65, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 1855,
                            "hardware_cylinder": 1851,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 120911,
                            "threshold": 120912,
                            "side_panels": {
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "side_glass_text": {"text": "", "position": null}
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "notes": "",
                            "measurements": {"overall_width": 900, "overall_height": 2090, "left_width": null, "right_width": null, "top_box_drop": null},
                            "collection": 1,
                            "touch_up_kit": 6,
                            "matching_paint": 11,
                            "trickle_vents": 1721,
                            "panel_category": 63,
                            "panel_core": 74,
                            "panel_depth": 3,
                            "hardware_suite": 67,
                            "frame_colour_internal": 82,
                            "argon_glass": 27,
                            "hinge_qty": 25,
                            "hardware_hinge_bolts": 754,
                            "hinge_spanner": 79,
                            "door_stop": 84,
                            "keyring": 86,
                        }
                    },
                    130: {
                        "attr": {
                            "fabricator": 8,
                            "door_range": 130,
                            "type": 10,
                            "frame_colour_external": 82,
                            "colour_range": 22,
                            "door_colour_internal": 986,
                            "door_drip_colour": 82,
                            "external_colour": 986,
                            "frame_material": 99,
                            "hardware_colour": 22,
                            "hardware_handle": 2918,
                            "hardware_hinge": 1854,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 2241,
                            "frame_style": {"frame_id": 65, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 1855,
                            "hardware_cylinder": 1851,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 120911,
                            "threshold": 120912,
                            "side_panels": {
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "side_glass_text": {"text": "", "position": null}
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "notes": "",
                            "cut_to_size": 63,
                            "measurements": {
                                "overall_width": "800",
                                "overall_height": "1890",
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null
                            },
                            "collection": 1,
                            "touch_up_kit": 6,
                            "matching_paint": 11,
                            "trickle_vents": 1721,
                            "panel_category": 52,
                            "panel_core": 29,
                            "panel_depth": 3,
                            "hardware_suite": 67,
                            "frame_colour_internal": 82,
                            "hinge_spanner": 79,
                            "hardware_hinge_bolts": 754,
                            "argon_glass": 27,
                            "hinge_qty": 25,
                            "closer": 598,
                            "door_stop": 84,
                            "keyring": 86,
                        }
                    },
                    131: {
                        "attr": {
                            "fabricator": 8,
                            "door_range": 131,
                            "frame_colour_external": 1,
                            "colour_range": 5,
                            "door_colour_internal": 1,
                            "door_drip_colour": 82,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 99,
                            "hardware_colour": 22,
                            "hardware_handle": 1051,
                            "hardware_hinge": 370,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 1,
                            "frame_style": {"frame_id": 65, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 167,
                            "hardware_cylinder": 837,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_suite": 8,
                            "hardware_spy_hole": 316,
                            "profile": 120911,
                            "threshold": 120912,
                            "side_panels": {
                                "left": 1,
                                "right": 1,
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "side_glass_text": {"text": "", "position": null},
                                "lower_sidepanel_type": 19
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 2,
                            "notes": "",
                            "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                            "hardware_hinge_bolts": 754,
                            "hardware_handle_split_spindle": 424,
                            "hardware_decorative_handle": 1112,
                            "collection": 1,
                            "touch_up_kit": 6,
                            "matching_paint": 11,
                            "trickle_vents": 1721,
                            "slab_cassette": 540,
                            "glass_design": 1,
                            "hinge_spanner": 79,
                            "door_stop": 84,
                            "keyring": 86,
                        }
                    },
                    132: {
                        "attr": {
                            "fabricator": 8,
                            "door_range": 132,
                            "type": 10,
                            "frame_colour_external": 82,
                            "colour_range": 22,
                            "door_colour_internal": 986,
                            "door_drip_colour": 82,
                            "external_colour": 986,
                            "frame_material": 99,
                            "hardware_colour": 22,
                            "hardware_handle": 2918,
                            "hardware_hinge": 1854,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 2205,
                            "frame_style": {"frame_id": 65, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 1855,
                            "hardware_cylinder": 1851,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 120911,
                            "threshold": 120912,
                            "side_panels": {
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "side_glass_text": {"text": "", "position": null}
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "notes": "",
                            "cut_to_size": 63,
                            "measurements": {
                                "overall_width": "950",
                                "overall_height": "800",
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null
                            },
                            "collection": 1,
                            "touch_up_kit": 6,
                            "matching_paint": 11,
                            "trickle_vents": 1721,
                            "panel_category": 54,
                            "panel_core": 31,
                            "panel_depth": 3,
                            "hardware_suite": 67,
                            "frame_colour_internal": 82,
                            "argon_glass": 27,
                            "hinge_qty": 25,
                            "hinge_spanner": 79,
                            "hardware_hinge_bolts": 754,
                            "closer": 598,
                            "door_stop": 84,
                            "keyring": 86,
                        }
                    },
                    133: {
                        "attr": {
                            "fabricator": 8,
                            "door_range": 133,
                            "type": 10,
                            "frame_colour_external": 82,
                            "colour_range": 23,
                            "door_colour_internal": 986,
                            "door_drip_colour": 82,
                            "external_colour": 986,
                            "frame_material": 99,
                            "hardware_colour": 22,
                            "hardware_handle": 2918,
                            "hardware_hinge": 1854,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 2283,
                            "frame_style": {"frame_id": 65, "checkedPanels": []},
                            "laminated_glass": 1,
                            "hardware_lock": 1855,
                            "hardware_cylinder": 1851,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_spy_hole": 316,
                            "profile": 120911,
                            "threshold": 120912,
                            "side_panels": {
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "side_glass_text": {"text": "", "position": null}
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 1,
                            "notes": "",
                            "cut_to_size": 63,
                            "measurements": {
                                "overall_width": "900",
                                "overall_height": "2090",
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null
                            },
                            "collection": 1,
                            "touch_up_kit": 6,
                            "matching_paint": 11,
                            "trickle_vents": 1721,
                            "glass_design": 1,
                            "panel_category": 53,
                            "panel_core": 30,
                            "panel_depth": 3,
                            "hardware_suite": 67,
                            "frame_colour_internal": 82,
                            "argon_glass": 27,
                            "hinge_spanner": 79,
                            "hardware_hinge_bolts": 754,
                            "hinge_qty": 25,
                            "closer": 598,
                            "door_stop": 84,
                            "keyring": 86,
                        }
                    },
                    148: {
                        "attr": {
                            "fabricator": 8,
                            "door_range": 148,
                            "type": 1,
                            "frame_colour_external": 1,
                            "colour_range": 17,
                            "door_colour_internal": 1,
                            "door_drip_colour": 11,
                            "external_colour": 11,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "hardware_colour": 22,
                            "hardware_handle": 1051,
                            "hardware_hinge": 370,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 2400,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "argon_glass": 27,
                            "hardware_lock": 167,
                            "hardware_cylinder": 841,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 357,
                            "hardware_knocker": 315,
                            "hardware_suite": 8,
                            "hardware_spy_hole": 316,
                            "profile": 7856,
                            "threshold": 82473,
                            "side_panels": {
                                "left": 1,
                                "right": 1,
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "side_glass_text": {"text": "", "position": null}
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 7861,
                            "drainage": 1,
                            "notes": "",
                            "measurements": {"overall_width": "890", "overall_height": "2090", "left_width": null, "right_width": null, "top_box_drop": null},
                            "hardware_hinge_bolts": 754,
                            "hardware_decorative_handle": 1112,
                            "collection": 1,
                            "touch_up_kit": 6,
                            "matching_paint": 11,
                            "trickle_vents": 1721,
                            "glass_design": 72,
                            "hardware_letterbox_cowl": 467,
                            "hardware_letterbox_pos": 521061,
                            "hinge_spanner": 79,
                            "door_stop": 84,
                            "keyring": 86,
                        }
                    },
                    149: {
                        "attr": {
                            "fabricator": 8,
                            "door_range": 149,
                            "type": 3,
                            "frame_colour_external": 1,
                            "colour_range": 5,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "hardware_colour": 22,
                            "hardware_handle": 3430,
                            "hinge_qty": 26,
                            "hardware_hinge": 2954,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 2460,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "argon_glass": 27,
                            "hardware_lock": 3432,
                            "hardware_cylinder": 3160,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_suite": 90,
                            "hardware_spy_hole": 316,
                            "profile": 7856,
                            "threshold": 7854,
                            "key_qty": 32,
                            "side_panels": {
                                "left": 1,
                                "right": 1,
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "side_glass_text": {"text": "", "position": null}
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 2,
                            "notes": "",
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null
                            },
                            "hardware_hinge_bolts": 754,
                            "collection": 1,
                            "touch_up_kit": 6,
                            "matching_paint": 11,
                            "trickle_vents": 1721,
                            "hardware_cylinder_stable": 3160,
                            "hardware_joining_bolt": 1285,
                            "meeting_bar_outside": 1,
                            "meeting_bar_inside": 1,
                            "hinge_spanner": 79,
                            "hardware_decorative_handle": 1112,
                            "hardware_escutcheon_stable": 1191,
                            "hardware_joining_bolt_pos": 568915,
                            "hardware_escutcheon_stable_pos": 568897,
                            "door_stop": 84,
                            "keyring": 86,
                        }
                    },
                    165: {
                        "attr": {
                            "fabricator": 8,
                            "door_range": 165,
                            "type": 15,
                            "frame_colour_external": 1,
                            "colour_range": 5,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "hardware_colour": 22,
                            "hardware_handle": 1051,
                            "hardware_hinge": 2954,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 8,
                            "frame_style": {
                                "frame_id": 1,
                                "checkedPanels": []
                            },
                            "laminated_glass": 1,
                            "argon_glass": 27,
                            "hardware_lock": 3666,
                            "hardware_cylinder": 837,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_suite": 8,
                            "hardware_spy_hole": 316,
                            "profile": 7856,
                            "threshold": 7854,
                            "side_panels": {
                                "left": 1,
                                "right": 1,
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "side_glass_text": {"text": "", "position": null},
                                "lower_sidepanel_type": 19,
                            },
                            "numerals": [
                                326,
                                326,
                                326,
                                326
                            ],
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "drainage": 2,
                            "notes": "",
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null
                            },
                            "hardware_hinge_bolts": 754,
                            "hardware_handle_split_spindle": 424,
                            "hardware_decorative_handle": 1112,
                            "collection": 1,
                            "touch_up_kit": 6,
                            "matching_paint": 11,
                            "trickle_vents": 1721,
                            "hinge_qty": 26,
                            "door_stop": 84,
                            "keyring": 86,
                        }
                    },
                    176: {
                        "attr": {
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill": 149,
                            "closer": 1125,
                            "door_range": 176,
                            "type": 6,
                            "colour_range": 5,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "drainage": 1,
                            "external_colour": 1,
                            "fabricator": 8,
                            "fitting_pack": 2136,
                            "frame_colour_external": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 3,
                            "frame_style": {
                                "frame_id": 31,
                                "checkedPanels": []
                            },
                            "glass_text": "",
                            "hardware_handle": 1065,
                            "hardware_hinge": 1100,
                            "hinge_side": 1,
                            "hardware_lock": 396,
                            "hardware_colour": 67,
                            "hardware_cylinder": 1157,
                            "hardware_hinge_bolts": 754,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_security_chain": 914,
                            "hardware_spy_hole": 918,
                            "hardware_suite": 10,
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null
                            },
                            "notes": "",
                            "numerals": [326, 326, 326, 326],
                            "opening_direction": 1,
                            "profile": 4221,
                            "secured_by_design": 2,
                            "side_panels": {
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "left_panel_glass_id": 24,
                                "right_panel_glass_id": 24,
                                "top_panel_glass_id": 24,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left": 52,
                                "right": 52,
                                "side_glass_text": {"text": "", "position": null}
                            },
                            "slab": 2966,
                            "threshold": 8384,
                            "hardware_spy_hole_pos": 11827,
                            "touch_up_kit": 6,
                            "door_bell": 8,
                            "matching_paint": 11,
                            "trickle_vents": 1721,
                            "hinge_qty": 25,
                            "hinge_spanner": 79,
                            "door_stop": 84,
                            "keyring": 86,
                            "fd_sticker": 98,
                        }
                    },
                    185: {
                        "attr": {
                            "fabricator": 8,
                            "door_range": 185,
                            "type": 1,
                            "colour_range": 5,
                            "frame_colour_external": 1,
                            "door_colour_internal": 1,
                            "door_drip_colour": 1,
                            "external_colour": 1,
                            "frame_colour_internal": 1,
                            "frame_material": 1,
                            "hardware_colour": 22,
                            "hardware_handle": 1051,
                            "hardware_hinge": 370,
                            "hinge_side": 1,
                            "opening_direction": 1,
                            "secured_by_design": 1,
                            "slab": 3073,
                            "frame_style": {"frame_id": 1, "checkedPanels": []},
                            "laminated_glass": 1,
                            "argon_glass": 27,
                            "hardware_lock": 167,
                            "hardware_cylinder": 837,
                            "hardware_security_chain": 317,
                            "hardware_letterbox": 318,
                            "hardware_knocker": 315,
                            "hardware_suite": 8,
                            "hardware_spy_hole": 316,
                            "profile": 7856,
                            "threshold": 7854,
                            "side_panels": {
                                "left": 1,
                                "right": 1,
                                "left_composite_id": null,
                                "right_composite_id": null,
                                "top_panel_glass_id": 19,
                                "left_composite_glass_id": null,
                                "right_composite_glass_id": null,
                                "left_panel_glass_id": 19,
                                "right_panel_glass_id": 19,
                                "side_glass_text": {"text": "", "position": null},
                                "lower_sidepanel_type": 19
                            },
                            "numerals": [326, 326, 326, 326],
                            "addons": {"left": {}, "right": {}, "top": {}, "bottom": {}},
                            "cill": 149,
                            "drainage": 2,
                            "notes": "",
                            "measurements": {
                                "overall_width": null,
                                "overall_height": null,
                                "left_width": null,
                                "right_width": null,
                                "top_box_drop": null
                            },
                            "hardware_hinge_bolts": 754,
                            "hardware_handle_split_spindle": 424,
                            "hardware_escutcheon_pos": 33578,
                            "hardware_decorative_handle": 1112,
                            "collection": 1,
                            "touch_up_kit": 6,
                            "matching_paint": 11,
                            "trickle_vents": 1721,
                            "hinge_qty": 25,
                            "match_previous_or_future_project": 77,
                            "match_previous_or_future_project_number": null,
                            "hinge_spanner": 79,
                            "closer": 598,
                            "door_stop": 84,
                            "keyring": 86,
                        }
                    },

                };
            },
            doSomething(val) {
                if (val) {
                    $('#signature-deluxe-under-door-box').show();
                } else {
                    $('#signature-deluxe-under-door-box').hide();
                }
            }
        },
        watch: {
            signature_deluxe: function (val) {
                this.doSomething(val);
            },
        }
    }
</script>
